
export default {
  async asyncData ({ $content, params, app: { i18n: { locale }, $seoMeta } }) {
    const post = await $content(locale, 'posts', params.id).fetch()
    $seoMeta.update($seoMeta.page(post.seoMeta))

    return { post }
  },
  vessel: {
    title: {
      fontSize: '3xl',
      marginBottom: 'sm',
    },
    article: {
      fontSize: 'lg',
      font: 'serif',
      marginTop: 'lg'
    }
  }
}
